import { createSlice, createAction, createSelector } from '@reduxjs/toolkit'
import moment from 'moment-timezone'

import { dateRangeConst } from 'constants/dateRangeConstants'
import { mappingEquipmentFilterData } from 'utils/mappingEquipmentFilterData'

const initialState = {
  facilityId: null,
  selectedDateRange: {
    id: dateRangeConst.currentMonth.id,
    label: dateRangeConst.currentMonth.label,
    value: {
      start_timestmp: moment().startOf('month').utc().unix(),
      end_timestmp: moment().endOf('month').utc().unix(),
    },
  },
  filter: {
    filteringData: { panels: [] },
    isFetchingFilteringData: false,
    selectedPanel: { label: 'Select panel' },
    selectedDevice: { label: 'Select device' },
  },
  consamptionData: {
    data: {
      consumption_by_ids: {},
      devices: [],
      timestamps_range: [],
      total_consumption: null,
      total_energy_intensity: null,
      total_estimated_cost: null,
      total_percentage: null,
    },
    isFetching: false,
  },
  lastUpdate: null,
}

export const getLastUpdateSelector = (state) => state.equipment.lastUpdate

export const getConsamptionDataIdsSelector = (state) =>
  state.equipment.consamptionData.data.consumption_by_ids

export const getConsamptionDataTimeStampSelector = (state) =>
  state.equipment.consamptionData.data.timestamps_range.map((ts) =>
    moment.unix(ts).format('YYYY-MM-DD[T]HH:mm:ss[.000Z]')
  )

export const getConsamptionDataDeviceSelector = (state) =>
  state.equipment.consamptionData.data.devices

export const getIsFetchingConsamptionDataSelector = (state) =>
  state.equipment.consamptionData.isFetching

export const getSelectedPanelSelector = (state) =>
  state.equipment.filter.selectedPanel

export const getSelectedDeviceSelector = (state) =>
  state.equipment.filter.selectedDevice

export const getEquipmentSelectedDateRangeSelector = (state) =>
  state.equipment.selectedDateRange

export const getEquipmentFacilityIdSelector = (state) =>
  state.equipment.facilityId

export const getFilteringDataSelector = (state) =>
  mappingEquipmentFilterData(state.equipment.filter.filteringData.panels)

export const getIsFetchingFilteringDataSelector = (state) =>
  state.equipment.filter.isFetchingFilteringData

export const getColorForChartIfSelectedDeviceFilter = createSelector(
  [getConsamptionDataDeviceSelector, getSelectedDeviceSelector],
  (devices, selectedDevices) => {
    return devices.find((d) => d?.id === selectedDevices?.value)?.color
  }
)

const equipmentSlice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    setEquipmentFacilityId(state, action) {
      state.facilityId = action.payload
    },
    setEquipmentSelectedDateRangeRedirect(state, action) {
      state.selectedDateRange = action.payload
    },
    setEquipmentSelectedDateRange(state, action) {
      state.selectedDateRange = action.payload
    },
    setEquipmentFilterData(state, action) {
      state.filter.filteringData = action.payload
    },
    setIsFetchingFilterData(state, action) {
      state.filter.isFetchingFilteringData = action.payload
    },
    setSelectedPanel(state, action) {
      state.filter.selectedPanel = action.payload
    },
    setSelectedDevice(state, action) {
      state.filter.selectedDevice = action.payload
    },
    setDefaultSelectedPanel(state, action) {
      state.filter.selectedPanel = action.payload
    },
    setDefaultSelectedDevice(state, action) {
      state.filter.selectedDevice = action.payload
    },
    clearSelectedFilterData(state) {
      state.filter.selectedPanel = initialState.filter.selectedPanel
      state.filter.selectedDevice = initialState.filter.selectedDevice
    },
    setConsamptionData(state, action) {
      state.consamptionData.data = action.payload
    },
    setIsFetchingConsaption(state, action) {
      state.consamptionData.isFetching = action.payload
    },
    setDefaultDateSelect(state, action) {
      state.selectedDateRange = action.payload
    },
    setLastUpdate(state, action) {
      state.lastUpdate = action.payload
    },
  },
})

export const getEquipmentFilterData = createAction(
  'equipment/getEquipmentFilterData'
)

export const getEquipmentConsamptionData = createAction(
  'equipment/getEquipmentConsamptionData'
)

export const {
  setEquipmentFacilityId,
  setEquipmentSelectedDateRangeRedirect,
  setEquipmentFilterData,
  setIsFetchingFilterData,
  setEquipmentSelectedDateRange,
  setSelectedPanel,
  setSelectedDevice,
  clearSelectedFilterData,
  setConsamptionData,
  setIsFetchingConsaption,
  setDefaultDateSelect,
  setDefaultSelectedPanel,
  setDefaultSelectedDevice,
  setLastUpdate,
} = equipmentSlice.actions

export default equipmentSlice.reducer
